module.exports = __webpack_public_path__ + "static/media/33.8dc8825d.JPG";